export async function importLsQuestionsCSV({ file, themeName, token }) {
  const formData = new FormData();
  formData.append("csvFile", file);
  formData.append("themeName", themeName);

  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/importLsQuestionsCSV`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to import CSV");
  }

  return resp.json();
}

export function exportLsQuestionsCSVUrl() {
  return `${process.env.REACT_APP_BACKEND_URL}/exportLsQuestionsCSV`;
}

export async function exportLsQuestionsCSV({ token, themeName }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/exportLsQuestionsCSV`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ themeName }),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to export questions");
  }

  return resp.blob();
}
